var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgNotifications = function SvgNotifications(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10.238 19.5c-.075.2-.113.4-.113.625 0 1.038.838 1.875 1.875 1.875a1.87 1.87 0 0 0 1.875-1.875c0-.225-.05-.425-.113-.625zM19.613 16.063c-.75-.438-1.363-1.175-1.363-2.313V9.5c0-3.45-2.95-6.25-6.25-6.25S5.75 6.05 5.75 9.5v4.25c0 1.125-.625 1.875-1.362 2.313-.5.3-1.138.712-1.138 1.212 0 .575.362.963 1.112.963h15.274999999999999c.75 0 1.113-.4 1.113-.963 0-.5-.625-.912-1.137-1.212",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 4.5A1.25 1.25 0 1 0 12 2a1.25 1.25 0 0 0 0 2.5"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNotifications);
export { ForwardRef as Icon };
export default "img/element-icons/notifications.46e80fb.svg";